export enum REFERRER_THEME {
  DRUGS = 'drugs',
  FRAUD = 'fraud',
  GAMBLING = 'gambling',
  PORNOGRAPHY = 'pornography',
  PROXY = 'proxy',
  PIRATE_SOFTWARE = 'pirate_software',
  VIOLENCE = 'violence',
  VIRUSES_AND_MALWARE = 'viruses_and_malware',
}
